/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UiNodeMeta } from './uiNodeMeta';
import { UiNodeAttributes } from './uiNodeAttributes';
import { UiText } from './uiText';


/**
 * Nodes are represented as HTML elements or their native UI equivalents. For example, a node can be an `<img>` tag, or an `<input element>` but also `some plain text`.
 */
export interface UiNode { 
    attributes: UiNodeAttributes;
    /**
     * Group specifies which group (e.g. password authenticator) this node belongs to. default DefaultGroup password PasswordGroup oidc OpenIDConnectGroup profile ProfileGroup link LinkGroup code CodeGroup totp TOTPGroup lookup_secret LookupGroup webauthn WebAuthnGroup passkey PasskeyGroup identifier_first IdentifierFirstGroup
     */
    group: UiNode.GroupEnum;
    messages: Array<UiText>;
    meta: UiNodeMeta;
    /**
     * The node\'s type text Text input Input img Image a Anchor script Script
     */
    type: UiNode.TypeEnum;
}
export namespace UiNode {
    export type GroupEnum = 'default' | 'password' | 'oidc' | 'profile' | 'link' | 'code' | 'totp' | 'lookup_secret' | 'webauthn' | 'passkey' | 'identifier_first';
    export const GroupEnum = {
        Default: 'default' as GroupEnum,
        Password: 'password' as GroupEnum,
        Oidc: 'oidc' as GroupEnum,
        Profile: 'profile' as GroupEnum,
        Link: 'link' as GroupEnum,
        Code: 'code' as GroupEnum,
        Totp: 'totp' as GroupEnum,
        LookupSecret: 'lookup_secret' as GroupEnum,
        Webauthn: 'webauthn' as GroupEnum,
        Passkey: 'passkey' as GroupEnum,
        IdentifierFirst: 'identifier_first' as GroupEnum
    };
    export type TypeEnum = 'text' | 'input' | 'img' | 'a' | 'script';
    export const TypeEnum = {
        Text: 'text' as TypeEnum,
        Input: 'input' as TypeEnum,
        Img: 'img' as TypeEnum,
        A: 'a' as TypeEnum,
        Script: 'script' as TypeEnum
    };
}


